import { getPostCommentWsSuccess } from 'redux/actions/postActions';
import store from 'store';
import { PostGetCommentType } from 'types/postTypes';

const { dispatch } = store;

export function handlePostComment({ cType, rObj, rParObj, rSrc, html }: PostGetCommentType): void {
  try {
    if (cType === '169:9') dispatch(getPostCommentWsSuccess({ cType, html, rObj, rParObj, rSrc }));
  } catch (e) {
    console.error('websocket error: ', e);
  }
}
